// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { createContextualIds, prepareFields } from "@insite/client-framework/Store/Data/Pages/PrepareFields";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { DeviceType } from "@insite/client-framework/Types/ContentItemModel";
import { PageModel } from "@insite/client-framework/Types/PageProps";
import { CustomPagesApiParameter } from "@mcmc/App/Services/CustomContentService";

import { Draft } from "immer";

interface LoadPagesCompletedAction {
    parameter: CustomPagesApiParameter;
    contentPages: PageModel[];
    currentLanguageId: string;
    defaultLanguageId: string;
    currentPersonaIds: string[];
    defaultPersonaId: string;
    currentDeviceType: DeviceType;
}

export type XContentState = {
    pagesGroupsById: {
        [key: string]: PageModel[];
    };
};

const initialContentState: XContentState = {
    pagesGroupsById: {},
};

const xContent = createTypedReducerWithImmer(initialContentState, {
    "xContent/CompleteLoadContentPages": (draft: Draft<XContentState>, action: LoadPagesCompletedAction) => {
        const { currentLanguageId, defaultLanguageId, currentPersonaIds, defaultPersonaId, currentDeviceType } = action;
        action.contentPages.every(page => {
            const contextualIds = createContextualIds(
                currentLanguageId,
                defaultLanguageId,
                currentDeviceType,
                currentPersonaIds,
                defaultPersonaId,
            );

            prepareFields(page, currentLanguageId, defaultLanguageId, contextualIds);
            return true;
        });

        draft.pagesGroupsById[action.parameter.nodeIds.join()] = action.contentPages;
    },
});

type xContentReducers = {
    xContent: typeof xContent;
} & typeof reducers;

(reducers as xContentReducers).xContent = xContent;
